<template>
    <div class="u-full-height" @click="closeClaimDropdown()">

        <div v-if="ie" class="ie-detection-container">
            <div class="ie-detection">
                <div class="ie-detection-text">It looks like you are currently using Internet Explorer {{ieVersion}}. This website works best in <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank">Chrome</a> or <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank">Firefox</a>. Please consider switching for an improved experience.</div>
                <button @click="hideWarningIE">Continue in Internet Explorer {{ieVersion}}</button>
            </div>
        </div>

        <!--import the passport component-->
        <passport></passport>

        <navigation></navigation>

        <right-col></right-col>

        <modal name="error_modal" no-default-button="true">
            <h1>
                Something has gone wrong!
            </h1>
            <p>
                We're sorry, there has been a problem with your request.<br><br>
                Rest assured, the BC Legal Development Team has been notified
                of this issue and will investigate and resolve this as soon as possible.
            </p>
            <p>
                If you would like to escalate the issue for immediate attention,
                please contact <a href="mailto:developers@bc-legal.co.uk">developers@bc-legal.co.uk</a>
                explaining the issue<span v-if="!errorToDisplay.exception">.</span>
                <span v-else> and including the error message below:</span>
            </p>
            <br>
            <div v-if="errorToDisplay.exception" style="margin-left: 40px; border-left: 5px solid #ccc; padding-left: 40px; padding-bottom: 20px; padding-top: 20px">
                <strong><pre>{{errorToDisplay.exception}} - {{errorToDisplay.url}}</pre></strong>
                <pre>{{errorToDisplay.message}}</pre>
            </div>
        </modal>

        <modal name="loggedout_modal" no-default-button="true" :style="heartbeatLoggedOut ? 'display: block' : ''">
            <h1>You have been logged out</h1>
            <div class="o-modal__exception-body">
                <pre>Please log back in to continue</pre>
            </div>
        </modal>
    </div>
</template>

<script>
    import Navigation from 'components/Navigation.vue'
    import RightCol from 'components/RightCol.vue'
    import Modal from 'components/modal/Modal.vue'
    import {mapActions, mapGetters} from 'vuex';
    import Passport from 'components/Passport.vue';

    export default {
        components: {Navigation, RightCol, Modal, Passport},
        data() {
            return {
                heartbeatLoggedOut: false,
                ie: false,
                ieVersion: null
            }
        },
        computed: {
            ...mapGetters('http', ['errorToDisplay', 'apiRouteRequestRunning', 'getMaintenanceStatus']),
            ...mapGetters('dropdown', ['dropdowns']),
            ...mapGetters('user', ['getUserId', 'getStatus']),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            ...mapGetters('headerWidth', ['theCurrentHeaderWidth', 'theCurrentHeaderPosition'])
        },
        methods: {
            ...mapActions('dropdown', ['close']),
            ...mapActions('user', ['heartbeat']),
            ...mapActions('windowWidth', ['updateWidth']),
            ...mapActions('headerWidth', ['updateHeaderWidth', 'updateHeaderPosition']),
            closeClaimDropdown(){
                if (this.dropdowns.name !== false) {
                    this.close('Create a new claim');
                }
            },
            hideWarningIE() {
                this.ie = false;
            }
        },
        watch: {
            getMaintenanceStatus: function (value) {
                if (value === true) {
                    this.$router.push({name: 'fiveOThree'})
                }
                this.$router.push({name: 'homepage'})
            }
        },
        mounted() {
            /*-------------------------------ie11 and lower detection code START - https://codepen.io/gapcode/pen/vEJNZN---------------------*/
            // Get IE or Edge browser version
            var version = detectIE();

            if (version === false) {
                //not ie
            } else if (version >= 12) {
                //ie edge
            } else {
                //internet explorer
                this.ie = true;
                this.ieVersion = version;
            }

            /**
            * detect IE
            * returns version of IE or false, if browser is not Internet Explorer
            */
            function detectIE() {
            var ua = window.navigator.userAgent;

            // Test values; Uncomment to check result …

            // IE 10
            // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

            // IE 11
            // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

            // Edge 12 (Spartan)
            // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

            // Edge 13
            // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
            }
            /*-------------------------------ie11 and lower detection code STOP - https://codepen.io/gapcode/pen/vEJNZN---------------------*/

            setInterval(() => {
//                this.heartbeat();
            }, 15000);

            this.updateWidth(window.innerWidth);

            if (window.location.hostname==="localhost" || window.location.hostname==="quantum.bclegal") {
                return;
            }

            window.onresize = () => {
                this.updateWidth(window.innerWidth);
                this.updateHeaderWidth({windowWidth: this.theCurrentWidth});
                this.updateHeaderPosition({windowWidth: this.theCurrentWidth});
            };
        }
    };
</script>

<style lang="sass" rel="stylesheet/scss">
    @import 'assets/sass/styles';
</style>



// WEBPACK FOOTER //
// App.vue?f30718aa